import * as angular from "angular";
import {IController} from "angular";

export class operationSubTaskTypeSelectCtrl implements IController {

  selectedType: any;
  title: string;
  options: any;
  onSelect: Function;

  /* @ngInject */
  constructor() {
  }


}

angular
  .module('bringoz.admin.orders')
  .component('operationSubTaskTypeSelect', {
    bindings: {
      selectedType: '<',
      options: '<',
      title: '@?',
      onSelect: '&'
    },
    template: require('./operation-sub-task-type-select.html').default,
    controller: operationSubTaskTypeSelectCtrl
  });
